import { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { getNextQuizSentence } from '../utils/dao';

function QuizRedirect() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const findAndRedirect = async () => {
      if (!id) {
        setError('No collection ID provided');
        return;
      }

      try {
        // Find the next sentence (REPEAT with elapsed time, or TODO)
        const nextSentence = await getNextQuizSentence(id);

        if (nextSentence) {
          // Redirect to the specific sentence
          navigate(`/collection/${id}/sentence/${nextSentence.id}`, { replace: true });
        } else {
          setError('No sentences to quiz. All sentences completed!');
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Unknown error');
      }
    };

    findAndRedirect();
  }, [id, navigate]);

  if (error) {
    return (
      <div className="container text-center mt-5">
        <p className="text-danger">{error}</p>
        <p className="mt-4">
          <Link to={`/collection/${id}`} className="text-primary">← Back to Collection</Link>
        </p>
      </div>
    );
  }

  return (
    <div className="container text-center mt-5">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Finding next sentence...</span>
      </div>
      <p className="mt-3">Finding next sentence...</p>
    </div>
  );
}

export default QuizRedirect;
